import { Box } from '@material-ui/core'
import Lottie from 'lottie-react'
import React from 'react'
import { useSelector } from 'react-redux'
import findingProvider from '../../../../assets/animations/find_provider.json'
import { selectLanguageContent } from '../../../../features/translation'
import { Typography } from '../../../../ui'
import { telehealthStyles } from '../styles'

export const FindingProvider = () => {
  const classes = telehealthStyles()
  const i18n = useSelector(selectLanguageContent)

  return (
    <>
      <Box className={classes.animationContainer}>
        <Lottie animationData={findingProvider} loop={true} />
      </Box>
      <Box className={classes.textContentContainer}>
        <Typography className={classes.title}>
          {i18n.provider_initial_title}
        </Typography>
        <Typography className={classes.body}>
          {i18n.provider_initial_message}
        </Typography>
      </Box>
    </>
  )
}
